// eslint-disable-next-line import/prefer-default-export
export const getTaskPercentage = (
  partialValue:number,
  totalValue: number
) => ((100 * partialValue) / totalValue).toFixed()
